<ng-container *ngIf="!isNewEDPScoreboard; else specialGameScoreboard">
    <ng-container *ngTemplateOutlet="participant1"></ng-container>
    <div class="score-wrapper">
        <div class="event-score">
            <span class="display-message">{{ displayMessage }}</span>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="participant2"></ng-container>
</ng-container>

<ng-template #specialGameScoreboard>
    <div class="special-game-scoreboard">
        <div class="event-header-live">
            <i class="live-icon"></i>
            <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard"> </ms-event-timer>
        </div>
        <ng-container *ngTemplateOutlet="participant1"></ng-container>
        <ng-container *ngTemplateOutlet="participant2"></ng-container>
    </div>
</ng-template>

<ng-template #participant1>
    <div class="participant">
        <ms-participant-image [participantImage]="event.participants[0].image" [sportId]="event.sport.id"> </ms-participant-image>
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[0]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false">
        </ms-scoreboard-participant>
    </div>
</ng-template>

<ng-template #participant2>
    <div class="participant">
        <ms-participant-image [participantImage]="event.participants[1].image" [sportId]="event.sport.id"> </ms-participant-image>
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[1]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false">
        </ms-scoreboard-participant>
    </div>
</ng-template>
